import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config';

const PrintButton = ({ fileId, fileUrl, label = "Печать", color = "blue", overlayText = null, className = "" }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const isFileAvailable = Boolean(fileId && fileUrl);

  // Функция отправки запроса на печать
  const handlePrint = async () => {
    if (!fileId) {
      console.error('ID файла не указан');
      alert('Файл недоступен для печати: отсутствует идентификатор файла');
      return;
    }

    if (!fileUrl) {
      console.error('URL файла не указан');
      alert('Ошибка: URL файла не найден');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem('token');

      // Формируем данные для запроса
      const requestData = {
        fileUrl: fileUrl,
        fileId: fileId
      };

      // Добавляем overlayText если передан (для добавления надписей на PDF)
      if (overlayText) {
        requestData.overlayText = overlayText;
      }

      // Используем локальный прокси endpoint вместо прямого обращения к серверу печати
      const response = await axios.post(
        `${API_URL}/api/print`,
        requestData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.success) {
        alert('Документ отправлен на печать!');
      } else {
        throw new Error(response.data.error || 'Ошибка при печати');
      }
    } catch (err) {
      console.error('Ошибка при печати:', err);
      setError(err.response?.data?.error || err.message || 'Ошибка при печати');
      alert('Ошибка при печати: ' + (err.response?.data?.error || err.message || 'Неизвестная ошибка'));
    } finally {
      setLoading(false);
    }
  };
  
  // Стили для кнопки
  const colorClasses = color === 'green'
    ? 'bg-green-500 hover:bg-green-600'
    : 'bg-blue-500 hover:bg-blue-600';
  const buttonClass = `px-2 py-1 text-xs sm:text-sm sm:px-3 rounded ${
    loading || !isFileAvailable
      ? 'bg-gray-400 cursor-not-allowed'
      : `${colorClasses} text-white`
  } ${className}`;
  
  return (
    <button
      onClick={handlePrint}
      disabled={loading || !isFileAvailable}
      className={buttonClass}
      title={!isFileAvailable ? 'Файл недоступен для печати' : undefined}
    >
      {loading ? 'Печать...' : label}
    </button>
  );
};

export default PrintButton;
